import get from 'lodash/get';
import { distinctUntilChanged } from 'rxjs/operators';

export function emitOnAttrChange(subject, key) {
  return subject.pipe(distinctUntilChanged((prev, curr) => get(prev, key) === get(curr, key)));
}
